import React from 'react';

type StravaIconProps = {
  isDisabled: boolean;
  className: string;
};

const StravaLogoIcon = (props: StravaIconProps) => (
  <svg
    className={props.className}
    width="48"
    height="48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-qa="strava-logo-icon"
  >
    <rect
      width="48"
      height="48"
      rx="6"
      fill={props.isDisabled ? '#cccccc' : '#FC4C02'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.683 32.337l-2.986-5.67h-4.364l7.371 14 7.296-14h-4.371l-2.946 5.67z"
      fill="#FFFFFE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.313 18.826l3.939 7.84H32L22.284 7.334l-9.617 19.334h5.757l3.89-7.841z"
      fill="#FFFFFE"
    />
  </svg>
);

export default StravaLogoIcon;
